export const orderReviewAmount = 45_000;

export const otherOrganizationType = "Other";
